/**
 * Unsaved-work registry (plan/portal-final/INTERFACES.md section 8). A screen
 * holding work a reload would lose (frames not yet queued, a voice note being
 * recorded, an edit in progress) marks itself busy under its own key and
 * clears the key when the work is queued, sent or discarded. The deployment
 * watcher reads `isBusy()` before reloading onto a new deployment.
 */

const holders = new Set<string>();
const listeners = new Set<() => void>();

export function setBusy(key: string, busy: boolean): void {
  const had = holders.has(key);
  if (busy) holders.add(key);
  else holders.delete(key);
  if (had !== busy) listeners.forEach((listener) => listener());
}

export function isBusy(): boolean {
  return holders.size > 0;
}

/** Calls `listener` whenever the busy state may have changed. Returns the unsubscribe. */
export function onBusyChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
